type ShareChannel = string
import React, { FC, useEffect } from "react"

import { sfxPlay } from "@/assets/audios/sfx"
import useSharePlatforms from "@/hooks/useSharePlatforms"
import styles from "./index.module.scss"

interface ShareChannelsProps {
    code?: string
    src?: string
    uid?: string
    nickname?: string
    download?: () => void
    onHasSharedChange?: (hasShared: boolean) => void
    isRecall?: boolean
    /** 分享图 DOM 的 ref，用于 App 内 skland.shareImage；由渲染分享图的父组件传入并挂到 img 上 */
    shareImageRef?: React.RefObject<HTMLImageElement>
}

export const ShareChannels: FC<ShareChannelsProps> = ({
    code,
    src,
    uid,
    nickname,
    download,
    onHasSharedChange,
    isRecall = false,
    shareImageRef,
}) => {

    const { platforms, onClickPlatform, hasShared } = useSharePlatforms({
        code,
        shareImageSrc: src,
        shareImageRef,
        uid,
        nickname,
        download: download || (() => {}),
        isRecall,
    })

    // 当 hasShared 变化时，通知父组件
    useEffect(() => {
        if (onHasSharedChange) {
            onHasSharedChange(hasShared)
        }
    }, [hasShared, onHasSharedChange])

    return (
        <div className={styles.shareSection}>
            {platforms.map((platform) => (
                <button
                    key={platform.key}
                    className={styles.platformButton}
                    onClick={() => {
                        onClickPlatform(platform.key as ShareChannel)
                        sfxPlay("click")
                    }}
                    type="button"
                >
                    <img
                        src={platform.icon}
                        alt={platform.title}
                        className={styles.platformIcon}
                    />
                </button>
            ))}
        </div>
    )
}
